import React from 'react';
import PropTypes from 'prop-types';

import { Paragraph, Text } from '@zillow/constellation';

export default function SummarySection({ header, id, children }) {
  return (
    <div id={`${id}-summary-section`}>
      <Text as="p" fontType="bodySmallHeading">
        {header}
      </Text>
      <Paragraph marginBottom="lg">{children}</Paragraph>
    </div>
  );
}

SummarySection.propTypes = {
  header: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
